export default {
      id: "home-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#home-usage",
      toString: function () {
        return this.url;
      }
    }